export default "__VITE_ASSET__BnhpgvF9__"